import React, { useState } from 'react';
import classnames from 'classnames';
import Button from '../../general/button/button';
import { CookieUtils, CookieBrowserPreferencesReturn } from '../utils';
import { defaultCookiePreferencesValue } from '../constants';
import { SwitchComp } from '../../inputs/switch/switch-comp';
import styles from './page-two.module.scss';

type Props = {
  onClose: (preferences: CookieBrowserPreferencesReturn) => void;
  changePage: () => void;
  cookieUtils: CookieUtils;
};

export const PageTwo = ({ onClose, changePage, cookieUtils }: Props) => {
  let cookieBrowserPreferences;
  try {
    cookieBrowserPreferences = cookieUtils.fetchCookieBrowserPreferences();
  } catch {
    cookieBrowserPreferences = defaultCookiePreferencesValue;
  }
  const [functional, setFunctional] = useState(
    cookieBrowserPreferences.functional,
  );
  const [analytical, setAnalytical] = useState(
    cookieBrowserPreferences.analytical,
  );
  return (
    <>
      <div className={styles['body-section']}>
        <h1 className={styles.header}>
          {polyglot.t('cookie_policy.page_two.header')}
        </h1>
        <p>{polyglot.t('cookie_policy.page_two.body')}</p>
      </div>
      <div className={styles['body-section']}>
        <h2 className={classnames(styles.subheader, 'first-subheader')}>
          {polyglot.t('cookie_policy.page_two.essential')}
        </h2>
        <div className={styles.row}>
          <div className={styles['first-column']}>
            <span className={styles.required}>
              {polyglot.t('cookie_policy.page_two.required')}
            </span>
          </div>
          <div data-hook='essential-body' className={styles.info}>
            {polyglot.t('cookie_policy.page_two.essential_body')}
          </div>
        </div>
        <h2 className={styles.subheader}>
          {polyglot.t('cookie_policy.page_two.functional')}
        </h2>
        <div className={styles.row}>
          <div className={styles['first-column']}>
            <div className={styles['switch-wrapper']}>
              <SwitchComp
                name='functional'
                isChecked={functional}
                onClick={() => setFunctional(!functional)}
                onText={polyglot.t('cookie_policy.page_two.on')}
                offText={polyglot.t('cookie_policy.page_two.off')}
              />
            </div>
          </div>
          <div data-hook='functional-body' className={styles.info}>
            {polyglot.t('cookie_policy.page_two.functional_body')}
          </div>
        </div>
        <h2 className={styles.subheader}>
          {polyglot.t('cookie_policy.page_two.analytical')}
        </h2>
        <div className={styles.row}>
          <div className={styles['first-column']}>
            <div className={styles['switch-wrapper']}>
              <SwitchComp
                name='analytical'
                isChecked={analytical}
                onClick={() => setAnalytical(!analytical)}
                onText={polyglot.t('cookie_policy.page_two.on')}
                offText={polyglot.t('cookie_policy.page_two.off')}
              />
            </div>
          </div>
          <div data-hook='analytical-body' className={styles.info}>
            {polyglot.t('cookie_policy.page_two.analytical_body')}
          </div>
        </div>
      </div>
      <div className={styles['button-section']}>
        <div className={styles['button-wrapper']}>
          <Button
            dataHook={'cookie-details'}
            text={polyglot.t('cookie_policy.page_two.show_cookie_details')}
            onClick={changePage}
            theme='text--on-surface'
          />
        </div>
        <div className={styles['button-wrapper']}>
          <Button
            dataHook={'set-cookies'}
            text={polyglot.t('cookie_policy.page_two.save_preferences')}
            onClick={() => {
              const preferences = cookieUtils.setCookieBrowserPreferences({
                mandatory: true,
                functional,
                analytical,
              });
              onClose(preferences);
            }}
          />
        </div>
      </div>
    </>
  );
};

PageTwo.displayName = 'PageTwo';
